import { createStore } from "vuex";
import { config } from "vuex-module-decorators";
import axios from "@/core/services/axios";
import AppConfig from "@/config/app.config";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import UserModule from "@/store/modules/user/user";
import TokensModule from "@/store/modules/tokens/tokens";
import investeeModule from "./modules/investees/investee";
import matchModule from "./modules/matches/matches";
import messageModule from "./modules/mesagges/message";
import filtersModule from "./modules/filters/filters";
import logsModule from "./modules/logs/logs";
import dashboardModule from "./modules/dashboard/dashboard";
import platformModule from "./modules/platform/platform";
import adminModule from "./modules/admin/admin";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    user: UserModule,
    tokens: TokensModule,
    list: investeeModule,
    message: messageModule,
    filters: filtersModule,
    logs: logsModule,
    dashboard: dashboardModule,
    match: matchModule,
    platform: platformModule,
    admin: adminModule,
  },
});

const useBrowserAuth = AppConfig.authSessionMode === "browser";

if (useBrowserAuth) {
  const accessToken = localStorage.getItem("accessToken");
  const accessExpiresAt = localStorage.getItem("accessExpiresAt");
  const refreshExpiresAt = localStorage.getItem("refreshExpiresAt");
  const refreshToken = localStorage.getItem("refreshToken");

  if (accessToken && accessExpiresAt) {
    store.commit("tokens/SET_ACCESS_TOKEN", { accessToken, accessExpiresAt });
  }
  if (refreshExpiresAt) {
    store.commit("tokens/SET_REFRESH_TOKEN", refreshExpiresAt);
  }
  if (refreshToken) {
    store.commit("tokens/SET_REFRESH_TOKEN_SECRET", refreshToken);
  }

  store.subscribe((mutation, state) => {
    if (mutation.type === "tokens/SET_ACCESS_TOKEN") {
      const token = state.tokens?.accessToken;
      if (token) {
        localStorage.setItem("accessToken", token);
      }
      return;
    }

    if (mutation.type === "tokens/CLEAR_TOKENS") {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    }
  });
}

store.$http = axios;

export default store;
